module.exports = __webpack_public_path__ + "img/hotel6.cbd7f24d.png";